export default {
    props: {
        label: {
            type: String,
            required: true,
        },
        ariaLabel: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },
    methods: {
        input(value) {
            this.$emit("input", value);
        },
    }
};



// WEBPACK FOOTER //
// ./src/components/AppInput/AppInput.js